module.exports = __webpack_public_path__ + "img/downloadIcon.1c818a1b.png";